// src/pages/quality/Create.jsx
import React from "react";
import { useNavigate, useParams } from "react-router-dom";

const Card = ({ title, desc, onClick }) => (
  <button
    onClick={onClick}
    className="block w-full text-left border rounded-xl p-4 hover:bg-gray-50"
  >
    <div className="text-lg font-semibold">{title}</div>
    <div className="text-sm text-gray-500 mt-1">{desc}</div>
  </button>
);

export default function QualityCreate() {
  const navigate = useNavigate();
  const { id: projectId } = useParams();

  return (
    <div className="p-4 space-y-6">
      <h2 className="text-xl font-bold">문서 만들기</h2>
      <div className="grid gap-4 md:grid-cols-3">
        <Card
          title="검측요청서"
          desc="입고 자재 검사/검수 기록 문서"
          onClick={() =>
            navigate(`/project/${projectId}/quality/CheckList/new`)
          }
        />
        <Card
          title="검측 CheckList"
          desc="공정 단계별 검사 문서"
          onClick={() =>
            navigate(`/project/${projectId}/quality/Inspection/new`)
          }
        />
        <Card
          title="부적합보고 (NCR)"
          desc="부적합/이탈 사항 보고 문서"
          onClick={() => navigate(`/project/${projectId}/quality/ncr/new`)}
        />
        <Card
          title="시정조치서 (CAR)"
          desc="시정 조치 보고 문서"
          onClick={() => navigate(`/project/${projectId}/quality/car/new`)}
        />
      </div>

      <div className="text-sm text-gray-500">
        * 생성 후 상세 화면에서 상태(임시저장/승인/종결), 검사 결과(합격/불합격)
        등을 설정합니다.
      </div>
    </div>
  );
}
